
export type State = {
    loading: boolean,
    requestsPending: number,
};

const objState = {
    loading: false,
    requestsPending: 0,
}

export const state: State = objState;
